import { defineSlotRecipe } from '@chakra-ui/react'

export const imageCard = defineSlotRecipe({
  className: 'ImageCard',
  slots: ['figure', 'caption', 'figcaption', 'heading', 'subHeading', 'link'],
  base: {
    figure: {
      bg: 'bg.layer2.default',
      borderRadius: 'xs',
      overflow: 'hidden',
      padding: 'var(--alto-sem-space-lg)',
      '& img': {
        borderRadius: 'xs',
      },
    },
    heading: {
      color: 'fg.accent.secondary',
      fontSize: 'var(--alto-sem-text-heading-sm-font-size)',
      lineHeight: 'var(--alto-sem-text-heading-sm-line-height)',
      letterSpacing: 'var(--alto-sem-text-heading-sm-letter-spacing)',
      fontWeight: 'semibold',
      marginTop: 'var(--alto-sem-space-sm)',
    },
    caption: {
      fontSize: 'var(--alto-sem-text-body-md-font-size)',
      fontWeight: 'normal',
      marginTop: 'var(--alto-sem-space-sm)',
    },
  },
})
